import { v3 } from '@adobe/edex/frontend/api/v3';
import { AxiosRequestConfig } from 'axios';

const baseURL = '/assignments';

export function paginate(config: AxiosRequestConfig) {
  return v3.get(`${baseURL}`, config);
}

export function get(id) {
  return v3.get(`${baseURL}/${id}`);
}

export function create(data) {
  return v3.post(`${baseURL}`, data);
}

export function update({ id, ...data }) {
  return v3.put(`${baseURL}/${id}`, data);
}

export function requestChanges(id) {
  return v3.post(`${baseURL}/${id}/request-changes`);
}

export function remove(id, courseID) {
  return v3.delete(`${baseURL}/${id}/course/${courseID}`);
}
